import { useEffect } from "react";
import "./document-view.css";

const defaultProps = {
  document: "path_to_doc",
};

export default function DocumentView(props = defaultProps) {
  useEffect(() => {
    // let meta = document.createElement('meta')
    // meta.content="width=device-width, initial-scale=2.0"
    // document.head.appendChild(meta)
  }, []);

  return <iframe className="document-view" src={`${props.document}#toolbar=0&navpanes=1&scrollbar=1&view=FitH`} frameBorder="0"></iframe>;
}
